import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Log environment variables on startup
console.log('Environment Variables in index.js:', {
  NODE_ENV: process.env.NODE_ENV,
  POKKETAPI_URL: process.env.REACT_APP_POKKETAPI_URL,
  SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL,
});

// Get initial data from window object
const initialData = window.INITIAL_DATA || {};

// Use createRoot instead of hydrateRoot
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App {...initialData} />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 